module.exports = __webpack_public_path__ + "img/hotel2.8171da6d.png";